import React from 'react';
import { Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Styles from './styles';

const GalleryItemCheckbox = ({
  children,
  layerName,
  selectLayer,
  selectBaseMap,
  isLayerSelected
}) => {
  return (
    <Col
      md={6}
      className={`px-1 border rounded ${isLayerSelected && 'border-primary'}`}
      title={layerName}
      style={{
        margin: 3,
        width: '18vw',
        height: '18vw',
        maxWidth: '150px',
        maxHeight: '160px',
        minWidth: '120px',
        minHeight: '145px',
        textAlign: '-webkit-center'
      }}
    >
      <Form.Text className="text-muted text-truncate overflow-hidden">{layerName}</Form.Text>
      <Styles.GalleryItemCheckbox checked={isLayerSelected}>
        {children}
        <Styles.LayerButtonsRow className="position-absolute w-100 d-flex justify-content-between px-1">
          <OverlayTrigger placement="top" overlay={<Tooltip>Add as base map</Tooltip>}>
            <div onClick={selectBaseMap} role="button" onKeyPress={() => {}} tabIndex={0}>
              <img
                src="/maps-buttons/mapa_base.svg"
                style={{ height: '34px', width: '34px', cursor: 'pointer' }}
                alt="Add as base map"
              />
            </div>
          </OverlayTrigger>
          <OverlayTrigger placement="top" overlay={<Tooltip>Add as layer</Tooltip>}>
            <div onClick={selectLayer} role="button" onKeyPress={() => {}} tabIndex={0}>
              <img
                src="/maps-buttons/capas.svg"
                style={{ height: '34px', width: '34px', cursor: 'pointer' }}
                alt="Add as layer"
              />
            </div>
          </OverlayTrigger>
        </Styles.LayerButtonsRow>
      </Styles.GalleryItemCheckbox>
    </Col>
  );
};

GalleryItemCheckbox.propTypes = {
  layerName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  selectLayer: PropTypes.func.isRequired,
  selectBaseMap: PropTypes.func.isRequired,
  isLayerSelected: PropTypes.bool.isRequired
};

export default GalleryItemCheckbox;
